import React from "react";
import styles from "../assets/buildingManagement.module.css";

const BuildingManagement = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>
              Elevating Property Management Standards
            </h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we offer comprehensive building management
              solutions tailored to meet the unique needs of property owners and
              managers. From ensuring compliance with safety regulations to
              optimizing operational efficiency, our expert team is committed to
              enhancing the value and functionality of your property.
            </p>
          </div>

          <div className={styles.whyChooseSection}>
            <h3 className={styles.categoryTitle}>
              Why Choose Global Guardians?
            </h3>

            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Expertise</h4>
                <p className={styles.featureDescription}>
                  With years of experience in property management and building
                  maintenance, we have the expertise to deliver superior
                  management solutions for a wide range of properties.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Comprehensive Approach</h4>
                <p className={styles.featureDescription}>
                  We take a holistic approach to building management, addressing
                  not only safety and compliance but also operational efficiency
                  and tenant satisfaction.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Certifications</h4>
                <p className={styles.featureDescription}>
                  Our commitment to safety is demonstrated through our
                  certifications in key areas such as fire safety, water safety,
                  electrical safety, gas safety, and asbestos management.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Client Satisfaction</h4>
                <p className={styles.featureDescription}>
                  We prioritize client satisfaction, striving to exceed
                  expectations through proactive communication, transparent
                  reporting, and responsive service.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>Our Services</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Safety Management</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Certified Compliance</h4>
                  <p className={styles.serviceDescription}>
                    We ensure that your property meets all relevant safety
                    regulations and standards, including certifications for fire
                    safety, water safety, electrical safety, gas safety, and
                    asbestos management.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Risk Assessment</h4>
                  <p className={styles.serviceDescription}>
                    Our team conducts comprehensive risk assessments to identify
                    potential hazards and vulnerabilities, implementing
                    preventive measures to mitigate risks and enhance safety.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Emergency Response</h4>
                  <p className={styles.serviceDescription}>
                    In the event of emergencies, our team is trained to respond
                    swiftly and effectively, minimizing damage and ensuring the
                    safety of occupants.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Operational Efficiency</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Maintenance Planning</h4>
                  <p className={styles.serviceDescription}>
                    We develop tailored maintenance plans to optimize the
                    performance and longevity of building systems and
                    infrastructure, reducing downtime and minimizing
                    disruptions.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Cost Optimisation</h4>
                  <p className={styles.serviceDescription}>
                    Through proactive maintenance and strategic planning, we
                    help minimize operational costs while maximizing the value
                    and efficiency of your property.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Tenant Satisfaction</h4>
                  <p className={styles.serviceDescription}>
                    Happy tenants are essential for the success of any property.
                    We prioritize tenant satisfaction by providing responsive
                    service, timely maintenance, and clear communication.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Certifications</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Fire Safety</h4>
                  <p className={styles.serviceDescription}>
                    Our properties are certified to meet all fire safety
                    regulations, ensuring the safety of occupants in the event
                    of a fire.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Water Safety</h4>
                  <p className={styles.serviceDescription}>
                    We adhere to strict water safety standards to prevent
                    contamination and ensure the quality of water for occupants.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Electrical Safety</h4>
                  <p className={styles.serviceDescription}>
                    Our properties undergo regular electrical inspections to
                    identify and address any potential hazards, ensuring the
                    safety of occupants.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Gas Safety</h4>
                  <p className={styles.serviceDescription}>
                    Gas appliances and installations are maintained and
                    inspected regularly to prevent leaks and ensure the safety
                    of occupants.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Asbestos Management</h4>
                  <p className={styles.serviceDescription}>
                    We have robust asbestos management plans in place to safely
                    manage and remove asbestos-containing materials, protecting
                    occupants from exposure.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Get in Touch</h4>
            <p className={styles.contactDescription}>
              Elevate your property management standards with Global Guardians.
              Contact us today to learn more about our building management
              solutions and certifications, and discover how we can add value to
              your property.
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:clientcare@global-guardians.co.uk">
                clientcare@global-guardians.co.uk
              </a>{" "}
              and we will be happy to discuss your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildingManagement;
